import script from "./ClassCompare.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClassCompare.vue?vue&type=script&setup=true&lang=ts"

import "./ClassCompare.vue?vue&type=style&index=0&id=168b4b04&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-168b4b04"]])

export default __exports__